<template>
  <div class="ux-field" :class="classes">
    <label class="ux-field-title" v-if="title">{{ title }}</label>
    <div class="ux-field-description" v-if="description">{{ description }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "UxFieldWrapper",
  props: {
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      var array = [];

      if (this.error) {
        array.push("ux-field-error");
      }

      return array;
    },
  },
};
</script>

<style lang="scss" scoped>
.ux-field {
  margin-bottom: 1em;

  .ux-field-message {
    border: red;
    background: rgba(red, 0.1);
    color: red;
    font-size: 0.7em;
    padding: 0.3em 0.5em;
    border-radius: 0 1em 1em;
    margin: 0.3em 0;
    display: inline-block;
  }
}

:deep(.ux-field-title) {
  margin-top: 0.5em;
  display: block;
  margin-bottom: 0.2em;
  font-size: 0.9em;
  font-weight: 500;
}

:deep(.ux-field-description) {
  font-size: clamp(12px, 0.8em, 16px);
  opacity: 0.5;
  margin-bottom: 0.5em;
}

.ux-field.ux-field-error > :deep(.ux-field-title) {
  color: red;
}

:deep(.ux-form-flex .ux-field-description) {
  // min-height: 2.6em;
}
</style>
